import React, { useMemo } from "react";
import styles from "./TabHeaders.module.css";
import { translate } from "../../../../../common/providers";
import { CRITERIA_TABS, VIEW_TABS } from "./tabs";
import { icon, IconComponent } from "../../../../../common/components";

export default function TabHeaders({ panel, sortDirection, sortKey, onClickSort }) {
	const tabs = useMemo(() => (panel === 0 && VIEW_TABS) || CRITERIA_TABS, [panel]);
	const isKeySorting = useMemo(() => sortKey === "name", [sortKey]);
	return (
		<div className={styles.main}>
			{tabs.map(
				(tab, index) =>
					(index === 0 && (
						<div
							key={tab.name}
							className={styles.sortLabel}
							role="presentation"
							onClick={() => onClickSort(tab.sortKey)}
						>
							{translate(tab.name)}
							{!isKeySorting && (
								<IconComponent
									className={`${styles.icon} ${styles["icon--inactive"]}`}
									icon={icon.faSort}
								/>
							)}
							{isKeySorting &&
								((sortDirection === "asc" && (
									<IconComponent className={styles.icon} icon={icon.faSortUp} />
								)) ||
									(sortDirection === "desc" && (
										<IconComponent className={styles.icon} icon={icon.faSortDown} />
									)))}
						</div>
					)) || <div key={tab.name}>{translate(tab.name)}</div>
			)}
			<div />
		</div>
	);
}
